// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

::ng-deep #holder > li {
  padding: 5px;
  margin: 2px;
  display: inline-block;
  border-color: #ddd;
}

::ng-deep #holder > li[data-page] {
  border: solid #a0a0a0 1px;
  border-radius: 5px;
}

::ng-deep #holder > li.separator:before {
  content: "...";
}

::ng-deep #holder > li.active {
  background-color: #f4f4f4;
  color: inherit;
}

::ng-deep #holder > li[data-page]:hover {
  cursor: pointer;
}

.product-images img {
  width: 100%;
  height: auto;
}

.org-filters label {
  padding: 3px;
}

::ng-deep.grey {
  background: rgba(236, 236, 236, 0.9);
}

.quantity {
  float: left;
  margin-right: 10px;
}
.quantity input {
  max-width: 50px;
}

.pdt-title {
  margin-bottom: 25px;
  font-family: "Museo-700";
  font-size: 36px;
}
@media only screen and (max-width: 767px) {
  .pdt-title {
    font-size: 24px;
  }
}

.image-imitation .image-youtube {
  border: 1px solid #ccc;
}

.form-right-thinking select {
  border: 1px solid #ddd;
  padding: 10px !important;
  height: 40px;
  background: #F8F8F8;
  color: #636363;
  font-family: "Museo-300";
  width: 100%;
  display: inline-block;
  margin-right: 1em;
  margin-top: 5px;
  margin-bottom: 15px;
  font-size: inherit;
}

.package-form {
  display: inline-block;
  width: 50%;
  padding-right: 40px;
}
.package-form label,
.package-form select {
  width: 100%;
}
.package-form label {
  line-height: 2em;
  padding: 0.75rem 0.75rem 0.75rem 0 !important;
}
.package-form select {
  border: 1px solid #ddd;
  padding: 10px !important;
  height: 40px;
  background: #F8F8F8;
  color: #636363;
  font-family: "Museo-300";
}
.package-form select:focus {
  outline: none;
}

.add-cart-section {
  display: inline-block;
  width: 100%;
}
.add-cart-section button {
  clear: both;
  margin-top: 10px;
}

.prod-price {
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  background-color: #1ab394;
  padding: 6px 12px;
  float: left;
  margin-right: 10px;
  width: 100%;
}

.product-content-table {
  margin: 20px 0 20px 20px;
}
@media only screen and (max-width: 991px) {
  .product-content-table {
    margin: 20px 0 0;
  }
}

.d-flex,
.btn-flex {
  display: flex;
  align-items: center;
  -webkit-align-items: center;
  -moz-align-items: center;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
}

.add-cart-section.pricing-table button {
  clear: none !important;
  margin-top: 0;
  margin-left: auto;
}

.client-price {
  clear: both;
  margin-top: 10px;
}

.product-content-table td {
  position: relative;
}
.product-content-table td span.qestion-icon {
  position: absolute;
  right: 8px;
}

#holder > li {
  padding: 5px;
  margin: 2px;
  display: inline-block;
  border-color: #ddd;
}

#holder > li[data-page] {
  border: solid #a0a0a0 1px;
  border-radius: 5px;
}

#holder > li.separator:before {
  content: "...";
}

#holder > li.active {
  background-color: #f4f4f4;
  color: inherit;
}

#holder > li[data-page]:hover {
  cursor: pointer;
}

.green-txt {
  font-size: 10px;
  font-style: normal;
  color: rgb(105, 190, 40);
}

.show-tier {
  margin-top: 15px;
  text-align: center;
}

.list-group-item {
  width: 48%;
  display: inline-block;
  margin-right: 10px;
}

.list-group-item.active a {
  color: #fff;
}

.form-table ul.list-group {
  display: table;
  width: 100%;
}
.form-table ul.list-group li.list-group-item {
  display: table-cell;
  width: auto;
}

.txt-bold {
  font-weight: bold;
}

.fa-question-circle {
  cursor: pointer;
}

.bottom-table th {
  text-align: right;
}

@media screen and (max-width: 480px) {
  .add-cart-section.pricing-table button {
    margin-left: 0;
  }
}
.cart-icons {
  float: right;
  text-align: right;
  top: 37px;
  right: 30px;
}
.cart-icons .dropdown-back {
  width: 22px;
  display: inline-block;
  position: relative;
  color: #636363;
  right: 25px;
}
.cart-icons .basket-item-count {
  position: absolute;
  left: 0;
  top: -12px;
  right: 0;
}

.pdt-price {
  margin-bottom: 10px;
  display: inline-block;
  font-size: 21px;
  color: #636363;
}
@media only screen and (max-width: 767px) {
  .pdt-price {
    font-size: 18px;
  }
}

.bottom-table th {
  background: #f1f1f2;
}

@media screen and (max-width: 991px) {
  .foursight-content {
    padding-top: 20px;
  }
}
.reset-input th {
  position: relative;
}
.reset-input th input[type=search] {
  width: 100% !important;
  border: 1px solid #e7eaec;
  padding: 6px 12px;
  font: inherit;
  color: inherit;
}
.reset-input th .reset-close {
  display: none;
  position: absolute;
  top: 0;
  right: 25px;
  bottom: 0;
  margin: auto;
  border-radius: 50%;
  background: #ddd;
  border: none !important;
  text-align: center;
  font-size: 14px;
  padding: 0px !important;
  height: 16px !important;
  width: 16px !important;
  color: #fff;
  line-height: 1.2 !important;
  font-family: Arial !important;
  transform: rotate(45deg) !important;
  -webkit-transform: rotate(45deg) !important;
}
.reset-input th:hover .reset-close {
  display: block;
}

.pr-0 {
  padding-right: 0;
}

.p-0 {
  padding: 0;
}

.orgs-name {
  cursor: pointer;
}

.product-content-table span.fname-asc, .product-content-table span.fname-desc {
  float: right;
}
.product-content-table th:first-child {
  width: 190px;
}
.product-content-table input[type=number] {
  border: 1px solid #ddd;
}

@media screen and (max-width: 640px) {
  .product-content-table input[type=number] {
    border: 1px solid #ddd;
    color: #676a6c;
  }
  .main-table-grid {
    display: block !important;
  }
  .main-table-grid div[class*=col-] {
    width: 100% !important;
  }
  .main-table-grid .product-content-table.table-responsive {
    margin-left: 0;
  }
}
ul.inline-list li {
  display: inline-block;
  margin-right: 10px;
}
@media only screen and (max-width: 767px) {
  ul.inline-list li {
    display: block;
  }
}

.input-relative {
  position: relative;
}
.input-relative .reset-close {
  right: 10px !important;
}

.wide-per-page {
  width: 65px;
}

::ng-deep .algo-details td,
::ng-deep .algo-details th {
  padding: 5px;
  border: 1px solid #ddd;
}

.product-detail {
  margin-bottom: 30px;
}

.vl-prc__tbl {
  overflow-x: auto;
}

::ng-deep .modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: none;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  outline: 0;
}
::ng-deep .modal.show {
  display: block !important;
}
::ng-deep .modal.grey {
  background: rgba(236, 236, 236, 0.9);
}
::ng-deep .modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
}
::ng-deep .modal.fade.in {
  opacity: 1;
}
::ng-deep .modal.in .modal-dialog {
  transform: translate(0, 0);
}
::ng-deep .modal.modal-open {
  overflow-x: hidden;
  overflow-y: auto;
}
::ng-deep .modal .modal-dialog {
  position: relative;
  width: auto;
  margin: 10px;
}
@media (min-width: 768px) {
  ::ng-deep .modal .modal-dialog {
    width: 600px;
    margin: 30px auto;
  }
}
::ng-deep .modal .modal-dialog .modal-content {
  background-clip: padding-box;
  background-color: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  outline: 0 none;
  position: relative;
}
::ng-deep .modal .modal-dialog .modal-content .close {
  float: right;
  font-size: 21px;
  font-weight: bold;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  filter: alpha(opacity=20);
  opacity: 0.2;
}
::ng-deep .modal .modal-dialog .modal-content .close:focus-visible {
  outline: none;
}
::ng-deep .modal .modal-dialog .modal-content button.close {
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  appearance: none;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body {
  padding: 20px 30px 30px 30px;
  position: relative;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form .table-responsive table {
  line-height: 20px;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form .table-responsive table th {
  text-align: left;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form ul {
  margin-top: 0;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form .list-group {
  padding-left: 0;
  margin-bottom: 20px;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form .list-group-item.active, ::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form .list-group-item.active:hover, ::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form .list-group-item.active:focus {
  z-index: 2;
  color: #fff;
  background-color: #337ab7;
  border-color: #337ab7;
  border-radius: 4px;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form .lbl {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 700;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form .btn-r .f-btn {
  padding: 5px 10px;
  line-height: 1.5;
  font-size: 12px;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .rw__cl form .btn-r .f-btn--info {
  background-color: #1dc5a3;
  border-color: #1dc5a3;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body.no-pad {
  padding: 0;
}
::ng-deep .modal .f-btn {
  color: #fff;
  font-size: 14px;
  border-color: #73BF38;
  background-color: #73BF38;
}
::ng-deep .modal .f-btn:hover {
  border-color: #4cae4c;
  background-color: #4cae4c;
}
::ng-deep .modal .f-btn--dngr {
  color: #fff;
  border-color: #ED5565;
  background-color: #ED5565;
}
::ng-deep .modal .f-btn--dngr:hover {
  border-color: #ec4758;
  background-color: #ec4758;
}
::ng-deep .modal .f-btn--info {
  color: #fff;
  border-color: #23c6c8;
  background-color: #23c6c8;
}
::ng-deep .modal .f-btn--info:hover {
  border-color: #21b9bb;
  background-color: #21b9bb;
}
::ng-deep .modal .f-btn--wrng {
  color: #fff;
  border-color: #f8ac59;
  background-color: #f8ac59;
}
::ng-deep .modal .f-btn--wrng:hover {
  border-color: #f7a54a;
  background-color: #f7a54a;
}

::ng-deep.modal-open {
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/store/volume-pricing/volume-pricing.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA7YA;EACE,YAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;AAgZF;;AA7YA;EACE,yBAAA;EACA,kBAAA;AAgZF;;AA7YA;EACE,cAAA;AAgZF;;AA7YA;EACE,yBAAA;EACA,cAAA;AAgZF;;AA7YA;EACE,eAAA;AAgZF;;AA5YE;EACE,WAAA;EACA,YAAA;AA+YJ;;AA1YE;EACE,YAAA;AA6YJ;;AAzYA;EACE,oCAAA;AA4YF;;AAzYA;EACE,WAAA;EACA,kBAAA;AA4YF;AA1YE;EACE,eAAA;AA4YJ;;AAxYA;EACE,mBAAA;EACA,wBAAA;EACA,eAAA;AA2YF;AAzYE;EALF;IAMI,eAAA;EA4YF;AACF;;AAzYA;EACE,sBAAA;AA4YF;;AAxYE;EACE,sBAAA;EACA,wBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,wBAAA;EACA,WAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AA2YJ;;AAvYA;EACE,qBAAA;EACA,UAAA;EACA,mBAAA;AA0YF;AAxYE;;EAEE,WAAA;AA0YJ;AAvYE;EACE,gBAAA;EACA,6CAAA;AAyYJ;AAtYE;EACE,sBAAA;EACA,wBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,wBAAA;AAwYJ;AArYE;EACE,aAAA;AAuYJ;;AAnYA;EACE,qBAAA;EACA,WAAA;AAsYF;AApYE;EACE,WAAA;EACA,gBAAA;AAsYJ;;AAlYA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;AAqYF;;AAlYA;EACE,wBAAA;AAqYF;AAnYE;EAHF;IAII,gBAAA;EAsYF;AACF;;AAnYA;;EAKE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,wBAAA;EACA,eAAA;EACA,uBAAA;EACA,oBAAA;AAsYF;;AAlYE;EACE,sBAAA;EACA,aAAA;EACA,iBAAA;AAqYJ;;AAjYA;EACE,WAAA;EACA,gBAAA;AAoYF;;AAjYA;EACE,kBAAA;AAoYF;AAlYE;EACE,kBAAA;EACA,UAAA;AAoYJ;;AAhYA;EACE,YAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;AAmYF;;AAhYA;EACE,yBAAA;EACA,kBAAA;AAmYF;;AAhYA;EACE,cAAA;AAmYF;;AAhYA;EACE,yBAAA;EACA,cAAA;AAmYF;;AAhYA;EACE,eAAA;AAmYF;;AAhYA;EACE,eAAA;EACA,kBAAA;EACA,wBDtLc;ACyjBhB;;AAhYA;EACE,gBAAA;EACA,kBAAA;AAmYF;;AAhYA;EACE,UAAA;EACA,qBAAA;EACA,kBAAA;AAmYF;;AAhYA;EACE,WAAA;AAmYF;;AA/XE;EACE,cAAA;EACA,WAAA;AAkYJ;AAhYI;EACE,mBAAA;EACA,WAAA;AAkYN;;AA7XA;EACE,iBAAA;AAgYF;;AA7XA;EACE,eAAA;AAgYF;;AA7XA;EACE,iBAAA;AAgYF;;AA7XA;EAEI;IACE,cAAA;EA+XJ;AACF;AA3XA;EACE,YAAA;EACA,iBAAA;EACA,SAAA;EACA,WAAA;AA6XF;AA3XE;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;AA6XJ;AA1XE;EACE,kBAAA;EACA,OAAA;EACA,UAAA;EACA,QAAA;AA4XJ;;AAxXA;EACE,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;AA2XF;AAzXE;EANF;IAOI,eAAA;EA4XF;AACF;;AAxXE;EACE,mBDvPkB;ACknBtB;;AAvXA;EACE;IACE,iBAAA;EA0XF;AACF;AAtXE;EACE,kBAAA;AAwXJ;AAtXI;EACE,sBAAA;EACA,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,cAAA;AAwXN;AArXI;EACE,aAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,WDhQa;ECiQb,2BAAA;EACA,6BAAA;EACA,mCAAA;EACA,2CAAA;AAuXN;AAnXM;EACE,cAAA;AAqXR;;AA/WA;EACE,gBAAA;AAkXF;;AA/WA;EACE,UAAA;AAkXF;;AA/WA;EACE,eAAA;AAkXF;;AA5WI;EAEE,YAAA;AA8WN;AA1WE;EACE,YAAA;AA4WJ;AAzWE;EACE,sBAAA;AA2WJ;;AAtWA;EACE;IACE,sBAAA;IACA,cDrViB;EC8rBnB;EAtWA;IACE,yBAAA;EAwWF;EArWA;IACE,sBAAA;EAuWF;EApWA;IACE,cAAA;EAsWF;AACF;AAnWA;EACE,qBAAA;EACA,kBAAA;AAqWF;AAnWE;EAJF;IAKI,cAAA;EAsWF;AACF;;AAnWA;EACE,kBAAA;AAsWF;AApWE;EACE,sBAAA;AAsWJ;;AAlWA;EACE,WAAA;AAqWF;;AAlWA;;EAEE,YAAA;EACA,sBAAA;AAqWF;;AAlWA;EACE,mBAAA;AAqWF;;AAhWE;EACE,gBAAA;AAmWJ;;AA9VA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,iCAAA;EACA,UAAA;AAiWF;AA/VE;EACE,yBAAA;AAiWJ;AA9VE;EACE,oCAAA;AAgWJ;AA5VI;EACE,mCAAA;AA8VN;AA3VI;EACE,UAAA;AA6VN;AAxVI;EACE,0BAAA;AA0VN;AAtVE;EACE,kBAAA;EACA,gBAAA;AAwVJ;AArVE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAuVJ;AArVI;EALF;IAMI,YAAA;IACA,iBAAA;EAwVJ;AACF;AAtVI;EACE,4BAAA;EACA,yBAAA;EACA,kCAAA;EACA,kBAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;AAwVN;AAtVM;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;AAwVR;AAtVQ;EACE,aAAA;AAwVV;AApVM;EACE,UAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EAEA,gBAAA;AAsVR;AAnVM;EACE,4BAAA;EACA,kBAAA;AAqVR;AA/UgB;EACE,iBAAA;AAiVlB;AA/UkB;EACE,gBAAA;AAiVpB;AA5Uc;EACE,aAAA;AA8UhB;AA3Uc;EACE,eAAA;EACA,mBAAA;AA6UhB;AA3UgB;EAGE,UAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;AA2UlB;AAvUc;EACE,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAyUhB;AArUgB;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;AAuUlB;AArUkB;EACE,yBAAA;EACA,qBAAA;AAuUpB;AA/TQ;EACE,UAAA;AAiUV;AA3TE;EACE,WAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;AA6TJ;AA3TI;EACE,qBAAA;EACA,yBAAA;AA6TN;AA1TI;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;AA4TN;AA1TM;EACE,qBAAA;EACA,yBAAA;AA4TR;AAxTI;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;AA0TN;AAxTM;EACE,qBAAA;EACA,yBAAA;AA0TR;AAtTI;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;AAwTN;AAtTM;EACE,qBAAA;EACA,yBAAA;AAwTR;;AAlTA;EACE,gBAAA;AAqTF","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../../assets/styles/variables';\n\n::ng-deep #holder>li {\n  padding: 5px;\n  margin: 2px;\n  display: inline-block;\n  border-color: #ddd;\n}\n\n::ng-deep #holder>li[data-page] {\n  border: solid #a0a0a0 1px;\n  border-radius: 5px;\n}\n\n::ng-deep #holder>li.separator:before {\n  content: '...';\n}\n\n::ng-deep #holder>li.active {\n  background-color: #f4f4f4;\n  color: inherit;\n}\n\n::ng-deep #holder>li[data-page]:hover {\n  cursor: pointer;\n}\n\n.product-images {\n  img {\n    width: 100%;\n    height: auto;\n  }\n}\n\n.org-filters {\n  label {\n    padding: 3px;\n  }\n}\n\n::ng-deep.grey {\n  background: rgba(236, 236, 236, 0.9);\n}\n\n.quantity {\n  float: left;\n  margin-right: 10px;\n\n  input {\n    max-width: 50px;\n  }\n}\n\n.pdt-title {\n  margin-bottom: 25px;\n  font-family: 'Museo-700';\n  font-size: 36px;\n\n  @media #{$mobile} {\n    font-size: 24px;\n  }\n}\n\n.image-imitation .image-youtube {\n  border: 1px solid #ccc;\n}\n\n.form-right-thinking {\n  select {\n    border: 1px solid #ddd;\n    padding: 10px !important;\n    height: 40px;\n    background: #F8F8F8;\n    color: #636363;\n    font-family: 'Museo-300';\n    width: 100%;\n    display: inline-block;\n    margin-right: 1em;\n    margin-top: 5px;\n    margin-bottom: 15px;\n    font-size: inherit;\n  }\n}\n\n.package-form {\n  display: inline-block;\n  width: 50%;\n  padding-right: 40px;\n\n  label,\n  select {\n    width: 100%;\n  }\n\n  label {\n    line-height: 2em;\n    padding: .75rem .75rem .75rem 0 !important;\n  }\n\n  select {\n    border: 1px solid #ddd;\n    padding: 10px !important;\n    height: 40px;\n    background: #F8F8F8;\n    color: #636363;\n    font-family: 'Museo-300';\n  }\n\n  select:focus {\n    outline: none;\n  }\n}\n\n.add-cart-section {\n  display: inline-block;\n  width: 100%;\n\n  button {\n    clear: both;\n    margin-top: 10px;\n  }\n}\n\n.prod-price {\n  font-size: 14px;\n  font-weight: 600;\n  color: #ffffff;\n  background-color: #1ab394;\n  padding: 6px 12px;\n  float: left;\n  margin-right: 10px;\n  width: 100%;\n}\n\n.product-content-table {\n  margin: 20px 0 20px 20px;\n\n  @media #{$tablet} {\n    margin: 20px 0 0;\n  }\n}\n\n.d-flex,\n.btn-flex {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  align-items: center;\n  -webkit-align-items: center;\n  -moz-align-items: center;\n  flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n  -moz-flex-wrap: wrap;\n}\n\n.add-cart-section.pricing-table {\n  button {\n    clear: none !important;\n    margin-top: 0;\n    margin-left: auto;\n  }\n}\n\n.client-price {\n  clear: both;\n  margin-top: 10px;\n}\n\n.product-content-table td {\n  position: relative;\n\n  span.qestion-icon {\n    position: absolute;\n    right: 8px;\n  }\n}\n\n#holder>li {\n  padding: 5px;\n  margin: 2px;\n  display: inline-block;\n  border-color: #ddd;\n}\n\n#holder>li[data-page] {\n  border: solid #a0a0a0 1px;\n  border-radius: 5px;\n}\n\n#holder>li.separator:before {\n  content: '...';\n}\n\n#holder>li.active {\n  background-color: #f4f4f4;\n  color: inherit;\n}\n\n#holder>li[data-page]:hover {\n  cursor: pointer;\n}\n\n.green-txt {\n  font-size: 10px;\n  font-style: normal;\n  color: $develop-color;\n}\n\n.show-tier {\n  margin-top: 15px;\n  text-align: center;\n}\n\n.list-group-item {\n  width: 48%;\n  display: inline-block;\n  margin-right: 10px;\n}\n\n.list-group-item.active a {\n  color: #fff;\n}\n\n.form-table {\n  ul.list-group {\n    display: table;\n    width: 100%;\n\n    li.list-group-item {\n      display: table-cell;\n      width: auto;\n    }\n  }\n}\n\n.txt-bold {\n  font-weight: bold;\n}\n\n.fa-question-circle {\n  cursor: pointer;\n}\n\n.bottom-table th {\n  text-align: right;\n}\n\n@media screen and (max-width: 480px) {\n  .add-cart-section.pricing-table {\n    button {\n      margin-left: 0;\n    }\n  }\n}\n\n.cart-icons {\n  float: right;\n  text-align: right;\n  top: 37px;\n  right: 30px;\n\n  .dropdown-back {\n    width: 22px;\n    display: inline-block;\n    position: relative;\n    color: #636363;\n    right: 25px;\n  }\n\n  .basket-item-count {\n    position: absolute;\n    left: 0;\n    top: -12px;\n    right: 0;\n  }\n}\n\n.pdt-price {\n  margin-bottom: 10px;\n  display: inline-block;\n  font-size: 21px;\n  color: #636363;\n\n  @media #{$mobile} {\n    font-size: 18px;\n  }\n}\n\n.bottom-table {\n  th {\n    background: $color-neutral-light;\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .foursight-content {\n    padding-top: 20px;\n  }\n}\n\n.reset-input {\n  th {\n    position: relative;\n\n    input[type=\"search\"] {\n      width: 100% !important;\n      border: 1px solid #e7eaec;\n      padding: 6px 12px;\n      font: inherit;\n      color:inherit;\n    }\n\n    .reset-close {\n      display: none;\n      position: absolute;\n      top: 0;\n      right: 25px;\n      bottom: 0;\n      margin: auto;\n      border-radius: 50%;\n      background: #ddd;\n      border: none !important;\n      text-align: center;\n      font-size: 14px;\n      padding: 0px !important;\n      height: 16px !important;\n      width: 16px !important;\n      color: $color-light-type;\n      line-height: 1.2 !important;\n      font-family: Arial !important;\n      transform: rotate(45deg) !important;\n      -webkit-transform: rotate(45deg) !important;\n    }\n\n    &:hover {\n      .reset-close {\n        display: block;\n      }\n    }\n  }\n}\n\n.pr-0 {\n  padding-right: 0;\n}\n\n.p-0 {\n  padding: 0;\n}\n\n.orgs-name {\n  cursor: pointer;\n}\n\n.product-content-table {\n  span {\n\n    &.fname-asc,\n    &.fname-desc {\n      float: right;\n    }\n  }\n\n  th:first-child {\n    width: 190px;\n  }\n\n  input[type=\"number\"] {\n    border: 1px solid #ddd;\n  }\n\n}\n\n@media screen and (max-width: 640px) {\n  .product-content-table input[type=\"number\"] {\n    border: 1px solid #ddd;\n    color: $body-content-color;\n  }\n\n  .main-table-grid {\n    display: block !important;\n  }\n\n  .main-table-grid div[class*=\"col-\"] {\n    width: 100% !important;\n  }\n\n  .main-table-grid .product-content-table.table-responsive {\n    margin-left: 0;\n  }\n}\n\nul.inline-list li {\n  display: inline-block;\n  margin-right: 10px;\n\n  @media #{$mobile} {\n    display: block;\n  }\n}\n\n.input-relative {\n  position: relative;\n\n  .reset-close {\n    right: 10px !important;\n  }\n}\n\n.wide-per-page {\n  width: 65px;\n}\n\n::ng-deep .algo-details td,\n::ng-deep .algo-details th {\n  padding: 5px;\n  border: 1px solid #ddd;\n}\n\n.product-detail {\n  margin-bottom: 30px;\n}\n\n.vl-prc {\n\n  &__tbl {\n    overflow-x: auto;\n  }\n}\n\n// Modal Design\n::ng-deep .modal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  overflow: hidden;\n  -webkit-overflow-scrolling: touch;\n  outline: 0;\n\n  &.show {\n    display: block !important;\n  }\n\n  &.grey {\n    background: rgba(236, 236, 236, 0.9);\n  }\n\n  &.fade {\n    .modal-dialog {\n      transition: transform 0.3s ease-out;\n    }\n\n    &.in {\n      opacity: 1;\n    }\n  }\n\n  &.in {\n    .modal-dialog {\n      transform: translate(0, 0);\n    }\n  }\n\n  &.modal-open {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n\n  .modal-dialog {\n    position: relative;\n    width: auto;\n    margin: 10px;\n\n    @media (min-width: 768px) {\n      width: 600px;\n      margin: 30px auto;\n    }\n\n    .modal-content {\n      background-clip: padding-box;\n      background-color: #FFFFFF;\n      border: 1px solid rgba(0, 0, 0, 0);\n      border-radius: 4px;\n      box-shadow: 0 1px 3px rgb(0 0 0 / 30%);\n      outline: 0 none;\n      position: relative;\n\n      .close {\n        float: right;\n        font-size: 21px;\n        font-weight: bold;\n        line-height: 1;\n        color: #000;\n        text-shadow: 0 1px 0 #fff;\n        filter: alpha(opacity=20);\n        opacity: 0.2;\n\n        &:focus-visible {\n          outline: none;\n        }\n      }\n\n      button.close {\n        padding: 0;\n        cursor: pointer;\n        background: transparent;\n        border: 0;\n        -webkit-appearance: none;\n        appearance: none;\n      }\n\n      .modal-body {\n        padding: 20px 30px 30px 30px;\n        position: relative;\n\n        .rw {\n          &__cl {\n            form {\n              .table-responsive {\n                table {\n                  line-height: 20px;\n\n                  th {\n                    text-align: left;\n                  }\n                }\n              }\n\n              ul {\n                margin-top: 0;\n              }\n\n              .list-group {\n                padding-left: 0;\n                margin-bottom: 20px;\n\n                &-item.active,\n                &-item.active:hover,\n                &-item.active:focus {\n                  z-index: 2;\n                  color: #fff;\n                  background-color: #337ab7;\n                  border-color: #337ab7;\n                  border-radius: 4px;\n                }\n              }\n\n              .lbl {\n                display: inline-block;\n                max-width: 100%;\n                margin-bottom: 5px;\n                font-weight: 700;\n              }\n\n              .btn-r {\n                .f-btn {\n                  padding: 5px 10px;\n                  line-height: 1.5;\n                  font-size: 12px;\n\n                  &--info {\n                    background-color: #1dc5a3;\n                    border-color: #1dc5a3;\n                  }\n                }\n              }\n            }\n          }\n        }\n\n        &.no-pad {\n          padding: 0;\n        }\n      }\n    }\n  }\n\n  .f-btn {\n    color: #fff;\n    font-size: 14px;\n    border-color: #73BF38;\n    background-color: #73BF38;\n\n    &:hover {\n      border-color: #4cae4c;\n      background-color: #4cae4c;\n    }\n\n    &--dngr {\n      color: #fff;\n      border-color: #ED5565;\n      background-color: #ED5565;\n\n      &:hover {\n        border-color: #ec4758;\n        background-color: #ec4758;\n      }\n    }\n\n    &--info {\n      color: #fff;\n      border-color: #23c6c8;\n      background-color: #23c6c8;\n\n      &:hover {\n        border-color: #21b9bb;\n        background-color: #21b9bb;\n      }\n    }\n\n    &--wrng {\n      color: #fff;\n      border-color: #f8ac59;\n      background-color: #f8ac59;\n\n      &:hover {\n        border-color: #f7a54a;\n        background-color: #f7a54a;\n      }\n    }\n  }\n}\n\n::ng-deep.modal-open {\n  overflow: hidden;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
